import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaBancosRecibosListaComponent {
  idEmpresa
  idNomina
  catalogo = {}
  generarPdf = false
  data
  seleccionados = []
  todoSeleccionado = false
  pagos = []
  todos = 0
  id_metodo_pago = 0
  id_tipo_pago = 0
  moneda_id = 0

  constructor ($q, $dialog, NominasNominaBancosRecibos, NominasCatalogoMetodoPago, NominasCatalogoMoneda, NominasCatalogoTipoPago) {
    this.$q = $q
    this.$dialog = $dialog
    this.NominasNominaBancosRecibosService = NominasNominaBancosRecibos
    this.NominasCatalogoMetodoPagoService = NominasCatalogoMetodoPago
    this.NominasCatalogoMonedaService = NominasCatalogoMoneda
    this.NominasCatalogoTipoPagoService = NominasCatalogoTipoPago
  }

  $onInit () {
    this.promise = this.$q.all([
      this.NominasNominaBancosRecibosService.get(this.idNomina)
        .then((response) => this.data = response.data)
        .then(() => {
          this.data = this.data.map((item) => {
            item.seleccionado = false
            if (item.id_banco_emisor === '005' || item.id_banco_emisor === '012' || item.id_banco_emisor === '007' || item.id_banco_emisor === '008') {
              this.todos += 1
            }
            return item
          })

          this.copia = this.data
        }),
      this.NominasCatalogoMetodoPagoService.get()
        .then((response) => {
          this.catalogo.metodo_pago = response.data.filter(item => item.id === 1 || item.id === 2)
          this.catalogo.metodo_pago.unshift({id: 0, descripcion: 'Todos'})
        }),
      this.NominasCatalogoMonedaService.get()
        .then((response) => {
          this.catalogo.moneda = response.data
          this.catalogo.moneda.unshift({id: 0, descripcion: 'Todas'})
        }),
      this.NominasCatalogoTipoPagoService.get()
        .then((response) => {
          this.catalogo.tipo_pago = response.data
          this.catalogo.tipo_pago.unshift({id: 0, descripcion: 'Todos'})
        }),
    ])
      .then(() => (this.filtrar()))
  }

  filtrar () {
    this.copia = this.data.filter((item) => {
      if (this.id_metodo_pago !== 0) {
        if (item.id_metodo_pago === this.id_metodo_pago) {
          return item
        }
      } else {
        return item
      }
    })

    this.copia = this.copia.filter((item) => {
      if (this.id_tipo_pago !== 0) {
        if (item.id_tipo_pago === this.id_tipo_pago) {
          return item
        }
      } else {
        return item
      }
    })

    this.copia = this.copia.filter((item) => {
      if (this.moneda_id !== 0) {
        if (item.id_moneda === this.moneda_id) {
          return item
        }
      } else {
        return item
      }
    })

    this.totalizar()
  }

  generar () {
    this.pagos = this.seleccionados.map((item) => item.pago_id)

    this.generarPdf = true
  }

  seleccionar (item) {
    item.seleccionado ? this.seleccionados.push(item) : this.seleccionados.splice(this.seleccionados.indexOf(item), 1)
    this.seleccionados.length === this.todos ? this.todoSeleccionado = true : this.todoSeleccionado = false
  }

  seleccionarTodo () {
    this.todoSeleccionado = !this.todoSeleccionado

    this.copia.forEach((item) => {
      if (item.id_banco_emisor === '005' || item.id_banco_emisor === '012' || item.id_banco_emisor === '007' || item.id_banco_emisor === '008') {
        item.seleccionado = this.todoSeleccionado
      }
    })

    this.totalizar()
  }

  totalizar () {
    this.seleccionados = this.copia.filter((item) => item.seleccionado)
  }
}

module.component('nominasNominaBancosRecibosLista', {
  controller: NominasNominaBancosRecibosListaComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
  },
})




// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/recibos/lista/component.js